// extracted by mini-css-extract-plugin
export default {"GreenNCAPEmbedIframe":"GreenNCAPEmbed_GreenNCAPEmbedIframe__WZLm9"};